"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.com.choose_model': '选择模型',
    'ai.com.choose_provider': '选择提供商',
    'ai.com.choose_avatar': '选择头像',
};
